import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { mealsAPI } from "../../services/api";
import MealForm from "../Vendor/MealForm";
import toast from "react-hot-toast";
import LoadingSpinner from "../../components/LoadingSpinner";
import styled from "styled-components";

const Container = styled.div`
  min-height: 100vh;
  background: #f8f9fa;
  padding: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const EditMeal = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const queryClient = useQueryClient();

  const { data, isLoading, error } = useQuery(
    ["meal", id],
    () => mealsAPI.getMeal(id),
    {
      enabled: !!id,
    }
  );

  const updateMealMutation = useMutation(
    ({ id, data }) => mealsAPI.updateMeal(id, data),
    {
      onSuccess: () => {
        toast.success("Meal updated successfully!");
        queryClient.invalidateQueries("meals");
        queryClient.invalidateQueries(["meal", id]);
        navigate("/admin/meals");
      },
      onError: (error) => {
        console.error("Error updating meal:", error);
        toast.error(
          error.response?.data?.message || "Failed to update meal"
        );
      },
    }
  );

  const handleSave = async (formData) => {
    try {
      await updateMealMutation.mutateAsync({ id, data: formData });
    } catch (error) {
      // Error is handled by the mutation's onError callback
      throw error;
    }
  };

  const handleCancel = () => {
    navigate("/admin/meals");
  };

  if (isLoading) {
    return (
      <Container>
        <LoadingSpinner />
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <div>
          <h2>Error Loading Meal</h2>
          <p>{error.response?.data?.message || "Failed to load meal data"}</p>
          <button onClick={() => navigate("/admin/meals")}>
            Back to Meals
          </button>
        </div>
      </Container>
    );
  }

  const meal = data?.data?.data?.meal;

  if (!meal) {
    return (
      <Container>
        <div>
          <h2>Meal Not Found</h2>
          <button onClick={() => navigate("/admin/meals")}>
            Back to Meals
          </button>
        </div>
      </Container>
    );
  }

  return <MealForm meal={meal} onSave={handleSave} onCancel={handleCancel} />;
};

export default EditMeal;

